import React from "react";

import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";

const Footer = () => (
  <footer className="footer bg-white mt-3">
    <Container fluid>
      <Row className="text-muted d-none">
        <Col xs={8} className="text-left">
          <ul className="list-inline d-flex flex-column flex-lg-row flex-wrap mb-0">
            <li className="list-inline-item">
              <Link to="/" className="text-muted mr-1">
                Inicio
              </Link>
            </li>
            <li className="list-inline-item">
              <Link to="privacy" className="text-muted mr-1">
                Privacidad
              </Link>
            </li>
            <li className="list-inline-item">
              <Link to="dashboard" className="text-muted mr-1">
                Terminos del Servicio
              </Link>
            </li>
            <li className="list-inline-item">
              <Link to="dashboard" className="text-muted">
                Contacto
              </Link>
            </li>
          </ul>
        </Col>
        <Col xs={4} className="text-right">
          <p className="mb-0">
            &copy; {new Date().getFullYear()} -{" "}
            <Link to="dashboard" className="text-muted">
              Plan Agropecuario
            </Link>
          </p>
        </Col>
      </Row>
    </Container>
  </footer>
);

export default Footer;
